import { generateUtilityClass } from '@mui/material';
import { unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';

export interface BannerClasses {
  /** Styles applied to the root element. */
  root: string;
}

export type BannerClassKey = keyof BannerClasses;

export function getBannerUtilityClass(slot: string): string {
  return generateUtilityClass('UnifyBanner', slot);
}

export const bannerClasses: BannerClasses = generateUtilityClasses(
  'UnifyBanner',
  ['root']
);

export default bannerClasses;
